module.exports = __webpack_public_path__ + "img/e838117.jpg";